import PropTypes from 'prop-types'
import React from 'react'

// eslint-disable-next-line no-unused-expressions
typeof window !== 'undefined' ? require('boxicons') : null

const FunctionContent = ({ className, image, title, text, iconColor }) => (
  <div className={`${className}`}>
    <box-icon name={image} color={iconColor} size="lg" className="my-3" />
    <div className="flex align-items-center">
      <h4 className="font-bold text-black font-inter">{title}</h4>
    </div>
    <p className="text-gray font-inter">{text}</p>
  </div>
)

FunctionContent.propTypes = {
  className: PropTypes.string,
  image: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string
}

export default FunctionContent



// WEBPACK FOOTER //
// ./src/components/newLayout/components/FunctionContent.js